// extracted by mini-css-extract-plugin
export var buttonContent = "_36-0";
export var centered = "_36-1";
export var centeredFlex = "_36-2";
export var errorText = "_36-3";
export var icon = "_36-4";
export var iconButtonContent = "_36-5";
export var monospace = "_36-6";
export var padded = "_36-7";